import http from './httpService';
import {getLanguage} from "react-switch-lang";

const nameValue = getLanguage() === "eng" ? "nameEn" : "name";

export function getAllDepartmentType() {
  return http.get(`/department-types?sort=${nameValue}`);
}

export function createDepartmentType(payload) {
  return http.post(`/department-types`, payload);
}

export function updateDepartmentType(payload) {
  return http.put(`/department-types`, payload);
}

export function deleteDepartmentType(id) {
  return http.delete(`/department-types/${id}`);
}
